__turbopack_context__.v({
  "accordionEditing": "NewsModal-module-scss-module__oLWLXq__accordionEditing",
  "blocksBackgroundColor": "NewsModal-module-scss-module__oLWLXq__blocksBackgroundColor",
  "blocksFontColor": "NewsModal-module-scss-module__oLWLXq__blocksFontColor",
  "buttonUnderlineEffect": "NewsModal-module-scss-module__oLWLXq__buttonUnderlineEffect",
  "container": "NewsModal-module-scss-module__oLWLXq__container",
  "content": "NewsModal-module-scss-module__oLWLXq__content",
  "contentContainer": "NewsModal-module-scss-module__oLWLXq__contentContainer",
  "editableTitle": "NewsModal-module-scss-module__oLWLXq__editableTitle",
  "loadingIndicator": "NewsModal-module-scss-module__oLWLXq__loadingIndicator",
  "meritChatCallout": "NewsModal-module-scss-module__oLWLXq__meritChatCallout",
  "modalCloseButton": "NewsModal-module-scss-module__oLWLXq__modalCloseButton",
  "modalContainer": "NewsModal-module-scss-module__oLWLXq__modalContainer",
  "modalContent": "NewsModal-module-scss-module__oLWLXq__modalContent",
  "modalDialog": "NewsModal-module-scss-module__oLWLXq__modalDialog",
  "navButtonsContainer": "NewsModal-module-scss-module__oLWLXq__navButtonsContainer",
  "newsModalContainer": "NewsModal-module-scss-module__oLWLXq__newsModalContainer",
  "nextPostButton": "NewsModal-module-scss-module__oLWLXq__nextPostButton",
  "postDate": "NewsModal-module-scss-module__oLWLXq__postDate",
  "prevPostButton": "NewsModal-module-scss-module__oLWLXq__prevPostButton",
  "secondaryNavBackgroundColor": "NewsModal-module-scss-module__oLWLXq__secondaryNavBackgroundColor",
  "shake": "NewsModal-module-scss-module__oLWLXq__shake",
  "sharePrintButtons": "NewsModal-module-scss-module__oLWLXq__sharePrintButtons",
  "subheader": "NewsModal-module-scss-module__oLWLXq__subheader",
  "themeBackgroundColor": "NewsModal-module-scss-module__oLWLXq__themeBackgroundColor",
  "themeFontColor": "NewsModal-module-scss-module__oLWLXq__themeFontColor",
  "themeFontFamily": "NewsModal-module-scss-module__oLWLXq__themeFontFamily",
  "titleContainer": "NewsModal-module-scss-module__oLWLXq__titleContainer",
  "transitionAppear": "NewsModal-module-scss-module__oLWLXq__transitionAppear",
  "transitionAppearActive": "NewsModal-module-scss-module__oLWLXq__transitionAppearActive",
  "transitionAppearDone": "NewsModal-module-scss-module__oLWLXq__transitionAppearDone",
  "transitionEnter": "NewsModal-module-scss-module__oLWLXq__transitionEnter",
  "transitionEnterActive": "NewsModal-module-scss-module__oLWLXq__transitionEnterActive",
  "transitionEnterDone": "NewsModal-module-scss-module__oLWLXq__transitionEnterDone",
  "transitionExit": "NewsModal-module-scss-module__oLWLXq__transitionExit",
  "transitionExitActive": "NewsModal-module-scss-module__oLWLXq__transitionExitActive",
  "transitionExitDone": "NewsModal-module-scss-module__oLWLXq__transitionExitDone",
  "viewMoreButton": "NewsModal-module-scss-module__oLWLXq__viewMoreButton",
});
